<template>
	<div v-if="cookieAgreed !== 'Y'" class="cookie-info animated slideInUp">
		<p>
			{{ $t("cookie.policy") }}
		</p>
		<a
			id="cookieInfoDetails"
			class="cookie-ok"
			href="/"
			@click="agreeCookie">
			{{ $t("cookie.agree") }}
			<span class="ts-icon is-angle-right-icon" aria-hidden="true"></span>
		</a>
	</div>
</template>
<script>
export default {
	name: "cookiePolicy",
	data() {
		return {
			cookieAgreed: localStorage.getItem("agreeCookie"),
		};
	},
	methods: {
		agreeCookie: function (event) {
			localStorage.setItem("agreeCookie", "Y");
			this.cookieAgreed = "Y";
			event.preventDefault();
		},
	},
};
</script>

<style scoped>
.cookie-info {
	position: fixed;
	bottom: 0;
	background: #f4eee0;
	margin: 15px;
	padding: 10px 20px;
	z-index: 9999;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	box-shadow: 2px 2px 5px rgba(50, 19, 0, 0.44);
	width: 80%;
	left: 10%;
	font-family: "Open Sans", "Noto Sans TC", "Times New Roman", sans-serif;
	font-weight: 400;
	color: #321300;
	background: #f4eee0;
	overflow-x: hidden;
}
.cookie-info .cookie-ok {
	min-width: 95px;
	text-align: center;
	background: #321300;
	color: #fff;
	max-height: 38px;
	padding: 7px;
	border-radius: 5px;
	text-decoration: none;
}

.cookie-info p {
	width: 90%;
	font-size: 0.875rem;
	line-height: 1.375rem;
}
.slideInUp {
	-webkit-animation-name: slideInUp;
	animation-name: slideInUp;
}
.animated {
	-webkit-animation-duration: 1s;
	animation-duration: 1s;
	-webkit-animation-fill-mode: both;
	animation-fill-mode: both;
}
</style>
